import React, { Component } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert } from 'react-bootstrap';
import { FaEnvelope, FaPhone, FaTrain, FaCity} from 'react-icons/fa';
import { MdLocalAirport } from 'react-icons/md';
import '../styles/Contacts.css';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';

const texts = {
    section: {
      en: 'Contacts',
      fr: 'Contacts',
    },
    block1: {
      title: {
        en: ['How to', 'Find Us'],
        fr: ['Où', 'Sommes-nous'],
      },
      p1: {
        en: 'Château La Croix de Millorit is located in Bayon-sur-Gironde, 1 km from Dordogne River.',
        fr: 'Le Château La Croix de Millorit est situé à Bayon-sur-Gironde, à 1 km de la rivière Dordogne.',
      },
      p2: {
        en: 'Bourg is the nearest town located within just 6 min drive from the Chateau.',
        fr: 'Bourg Sur Gironde, la commune la plus proche du Château,',
      },
      p3: {
        en: 'Another town nearby is Blaye, it`s 10 minutes drive. You can get here from Bordeaux in aprox.',
        fr: 'n’est qu’a 6 mn en voiture du Château et à 10 mn de la petite ville de Blaye réputée pour sa citadelle Vauban.',
      },
      p4: {
        en: '45 minutes and the nearest airport is Aéroport de Mérignac (Bordeaux) also 45 minutes away.',
        fr: 'La ville de Bordeaux et son aéroport de Mérignac ne sont qu’à 45mn en voiture.',
      },
    },
    block2: {
        title: {
          en: ['Contact', 'Us'],
          fr: ['Nous', 'Contacter'],
        },
        p1: {
          en: 'phone',
          fr: 'tel.',
        },
        p2: {
            en: '(Monday-Friday from 9am till 6pm)',
            fr: '(du lundi au vendredi de 9h à 18h)',
          },
        p3: {
            en: 'e-mail',
            fr: 'courriel',
          },
        p4: {
            en: 'Your name',
            fr: 'Nom',
          },
        p5: {
            en: 'Your e-mail',
            fr: 'Adresse mail',
          },
        p6: {
            en: 'Subject',
            fr: 'Sujet',
          },
        p7: {
            en: 'SEND',
            fr: 'ENVOYER',
          },
      },
  }

const animate =(inView, animationType, delay, speed)=>{
  const animation = `animate__${animationType}`;
  const animateSpeed = speed ? `animate__${speed}` : '';
  return `animate__animated ${inView ? animation : ''} animate__delay-${delay}s ${animateSpeed}`;
}

const setSection =(section, props, inView)=>{
    if(inView && props.nav !== section){
      props.setNav(section);
    }
  }

const FindUsSection =(props)=> {
    const section = "contacts";
    const lang = props.lang;
    const { ref, inView } = useInView({threshold: 0.5});
    useEffect(() => {
        setSection(section, props, inView);
    });
    return(
        <div ref={ref} className="container" id="findus">
            <div className="section-title">
                <h2 className={animate(inView, 'bounceInDown', 0.2)}>{texts.section[lang]}</h2>
                <h3 className={animate(inView, 'flipInX', 1)}>{texts.block1.title[lang][0]} <span>{texts.block1.title[lang][1]}</span></h3>
                <p className={animate(inView, 'fadeIn', 1, 'slow')}>{texts.block1.p1[lang]}</p>
            </div>
            <div className="row content locationItemsWrapper">
                <div className="col">
                    <div className={`locationIconWrapper ${animate(inView, 'zoomInLeft', 1)}`}>
                        <FaCity className='locationIcon'/>
                        <p>6 min</p>
                    </div>
                </div>
                <div className="col">
                    <div className={`locationIconWrapper ${animate(inView, 'zoomInUp', 1)}`}>
                        <MdLocalAirport className='locationIcon'/>
                        <p>45 min</p>
                    </div>
                </div>
                <div className="col">
                    <div className={`locationIconWrapper ${animate(inView, 'zoomInRight', 1)}`}>
                        <FaTrain className='locationIcon'/>
                        <p>45 min</p>
                    </div>
                </div>
            </div>
            <div className="row content">
                <div className="col-lg-12">
                    <p className={`location-text ${animate(inView, 'fadeIn', 0, 'slow')}`}>
                    {texts.block1.p2[lang]}<br></br>
                    {texts.block1.p3[lang]} <br></br>
                    {texts.block1.p4[lang]} 
                    </p>
                </div>
            </div>

            <div className='map-wrapper'>
                <iframe className='map' title='map' src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d721525.7338967925!2d-0.601474!3d45.056181!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xdc966ed043857a70!2sLa%20Croix%20De%20Millorit!5e0!3m2!1sen!2suk!4v1651005773800!5m2!1sen!2suk" width="100%" height="350px" allowFullScreen="" loading="lazy"></iframe>
            </div>
        </div>
    );
}

export default class Contacts extends Component {
    state = {
        name: '',
        email: '',
        subject: '',
        message: '',
        status: 'ready',
        alert: 'secondary',
        statusMsg: '',
    }

    handleClickSend =()=> {
        this.setState({status: 'process'});
        const mailData = {
            name: this.state.name,
            email: this.state.email,
            subject: this.state.subject,
            message: this.state.message,
        }
        fetch('/api/email', {
            method: 'POST',
            headers: {
              'Accept': 'application/json, text/plain, */*',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(mailData)
          }).then((res) => {
                res.json().then((body) => {
                    console.log(body)
                    this.setState({
                        status: 'sent',
                        alert: res.status === 200 ? 'success' : 'danger',
                        statusMsg: body.message,
                    });
                });
          })
    }

    render() {
    return (
    <section id="contacts" className="contacts section">
        <FindUsSection lang={this.props.lang} nav={this.props.nav} setNav={(section)=>{this.props.setNav(section)}}/>

        <div className="container" id="contactus">
            <div className="section-title">
                <h3>{texts.block2.title[this.props.lang][0]} <span>{texts.block2.title[this.props.lang][1]}</span></h3>
            </div>
            
            <Container className="emailFormContainer">
                <Row>
                    <Col lg={2} md={12} className='leftCol'>
                        <div className="email">
                            <div className='contactIconsBox'><FaPhone className='contactIcons'/></div>
                            <h5>{texts.block2.p1[this.props.lang]}</h5>
                        </div>
                    </Col>
                    <Col lg={10} md={12}>     
                        <p className='phone'><span>+33 6 6307 5398</span> {texts.block2.p2[this.props.lang]}</p>
                    </Col>
                </Row>
                <Row>
                    <Col lg={2} md={12} className='leftCol'>
                        <div className="email">
                            <div className='contactIconsBox'><FaEnvelope className='contactIcons'/></div>
                            <h5>{texts.block2.p3[this.props.lang]}</h5>
                        </div>
                    </Col>
                    <Col lg={10} md={12}>
                        <Form className={this.state.status === 'sent' ? 'hidden' : ''}>
                            <Form.Group className="mb-3" controlId="emailForm.name">
                                <Form.Control 
                                    type="email" 
                                    placeholder={texts.block2.p4[this.props.lang]}
                                    value={this.state.name}
                                    onChange={(event)=>{this.setState({name: event.target.value})}}
                                    />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="emailForm.email">
                                <Form.Control 
                                    type="email" 
                                    placeholder={texts.block2.p5[this.props.lang]} 
                                    value={this.state.email}
                                    onChange={(event)=>{this.setState({email: event.target.value})}}
                                    />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="emailForm.subject">
                                <Form.Control 
                                    type="email" 
                                    placeholder={texts.block2.p6[this.props.lang]} 
                                    value={this.state.subject}
                                    onChange={(event)=>{this.setState({subject: event.target.value})}}
                                    />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="emailForm.message">
                                <Form.Control 
                                    as="textarea" 
                                    rows={3} 
                                    value={this.state.message}
                                    onChange={(event)=>{this.setState({message: event.target.value})}}
                                    />
                            </Form.Group>
                            <Button variant="primary" onClick={this.handleClickSend} className='sendButton'>
                                {
                                    this.state.status === 'process' ? 
                                        <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className={`spinner ${this.state.status !== 'process' ? 'invisible' : ''}`}
                                        />
                                        : texts.block2.p7[this.props.lang]
                                }
                            </Button>
                        </Form>
                        <div className={`alertContainer ${this.state.status === 'ready' || this.state.status === 'process' ? 'hidden' : ''}`}>
                            <Alert variant={this.state.alert}>
                                <p className='alertText'>{this.state.statusMsg}</p>
                            </Alert>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    </section>
  );
  }
}